import React from 'react';
import {Box, ButtonBase, Typography} from '@mui/material';
import {CARTE, NAVY, PISTE_PROGRESSION, TEXTE, TEXTE_SECONDAIRE, VERT_PROGRESSION} from '../tokens.js';

function formater(chiffre) {
    if (chiffre == null) return '—';
    return typeof chiffre === 'number' ? chiffre.toLocaleString('fr-FR') : chiffre;
}

/**
 * Tuile KPI : chiffre 800 navy, libellé, sous-ligne, barre de progression (0..1).
 * `chiffre == null` -> « — » (jamais de valeur inventée). `tailleChiffre` entre 36 et 56 px.
 */
export default function TuileKpi({chiffre, libelle, sousLigne, progression, onClick, tailleChiffre = 36}) {
    const contenu = (
        <Box sx={{textAlign: 'left', width: '100%'}}>
            <Typography component="div" sx={{fontSize: tailleChiffre, fontWeight: 800, lineHeight: 1.1, color: NAVY}}>
                {formater(chiffre)}
            </Typography>
            <Typography component="div" sx={{mt: '6px', fontSize: 12, fontWeight: 600, color: TEXTE}}>{libelle}</Typography>
            {sousLigne != null && (
                <Typography component="div" sx={{mt: '2px', fontSize: 12, color: TEXTE_SECONDAIRE}}>{sousLigne}</Typography>
            )}
            {progression != null && (
                <Box sx={{mt: '10px', height: 12, borderRadius: '999px', backgroundColor: PISTE_PROGRESSION, overflow: 'hidden'}}>
                    <Box sx={{height: '100%', width: `${Math.round(Math.min(Math.max(progression, 0), 1) * 100)}%`, backgroundColor: VERT_PROGRESSION, borderRadius: '999px'}}/>
                </Box>
            )}
        </Box>
    );
    const carte = {
        display: 'block', width: '100%', p: '16px 20px', boxSizing: 'border-box', backgroundColor: CARTE.fond,
        border: `1px solid ${CARTE.bordure}`, borderRadius: `${CARTE.radius}px`, boxShadow: CARTE.ombre,
    };
    if (onClick) {
        return <ButtonBase onClick={onClick} sx={{...carte, '&:hover': {borderColor: NAVY}}}>{contenu}</ButtonBase>;
    }
    return <Box sx={carte}>{contenu}</Box>;
}
